import axiosInstance from './axiosConfig';


// fulfillmentChannel record getting here
export const timeBased = async ({ timeBasedFilter, formattedEnd , formattedStart , selectedIds }) => {
  const { productId = [], categoryId = [] } = selectedIds;
  const productIdsStr = productId.join(',');
  const categoryIdsStr = categoryId.join(',');
  const response = await axiosInstance.get(`/time_sales_analysis/time_based?filter=${timeBasedFilter}&start_date=${formattedStart}&end_date=${formattedEnd}&product_ids=${productIdsStr}&category_ids=${categoryIdsStr}`);
  return response.data;
};

// regionalShare record getting here
export const weeklySalesDistriution = async ({ formattedEnd , formattedStart , selectedIds}) => {
  const { productId = [], categoryId = [] } = selectedIds;
  const productIdsStr = productId.join(',');
  const categoryIdsStr = categoryId.join(',');
  
  const response = await axiosInstance.get(`/time_sales_analysis/weekly_sales_distriution?start_date=${formattedStart}&end_date=${formattedEnd}&product_ids=${productIdsStr}&category_ids=${categoryIdsStr}`);
  return response.data;
};

// eliteWarehouserecord getting here
export const timeSalesAnalysis = async ({ formattedEnd , formattedStart , selectedIds }) => {
  const { productId = [], categoryId = [] , parentProductId = [] } = selectedIds;
  const productIdsStr = productId.join(',');
  const categoryIdsStr = categoryId.join(',');
  const parentProductIdStr = parentProductId.join(',');
  const viewType = localStorage.getItem("viewType");

  //  Build query params dynamically
  let url = `/time_sales_analysis?start_date=${formattedStart}&end_date=${formattedEnd}&category_ids=${categoryIdsStr}&parent_product_id=${parentProductIdStr}`;

  if (viewType === "variation" || viewType === "product") {
    url += `&product_wise=${viewType}`;
  }

  const response = await axiosInstance.get(url);
  return response.data;
};
